import {Helmet} from 'react-helmet'

export const PageHelmet = ({title}: {title: string}) => (
    <Helmet>
        <title>{title}</title>
    </Helmet>
)
